import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";

export default class ModalsDomainAddDnssecRecord extends Component {
  @service modal;
  @service intl;

  @tracked selectedFlags = 257;
  @tracked selectedAlgorithm = 13;
  @tracked dnskey;

  get isSubmitDisabled() {
    return !(this.selectedFlags && this.selectedAlgorithm && this.dnskey?.length > 0);
  }

  get flagsOptions() {
    return [
      {
        value: 256,
        label: "256",
      },
      {
        value: 257,
        label: "257",
      },
    ];
  }

  get algorithmOptions() {
    return [
      {
        value: 8,
        label: "8 RSA/SHA-256",
      },
      {
        value: 10,
        label: "10 RSA/SHA-512",
      },
      {
        value: 13,
        label: "13 ECDSA/SHA-256",
      },
      {
        value: 14,
        label: "14 ECDSA/SHA-384",
      },
    ];
  }

  get task() {
    return this.args.params.task;
  }

  submitTask = task(async () => {
    const task = this.task;

    await task.perform({
      flags: this.selectedFlags,
      algorithm: this.selectedAlgorithm,
      dnskey: this.dnskey,
    });

    this.modal.close();
  });

  @action
  handleFormChange({ flags, algorithm, dnskey }) {
    this.selectedFlags = flags;
    this.selectedAlgorithm = algorithm;
    this.dnskey = dnskey;
  }
}
